import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../partials/Header';
import Footer from '../partials/Footer';

const Notfound = (props) => {
	let { slug } = useParams();
	return (
		<div>
			<Header />
			<h1>this is the slug: {slug}</h1>
			<Footer />
		</div>
	)
}

export default Notfound;
